import { animate as animate14 } from 'vendor';

class CartBar extends HTMLElement {
  constructor() {
    super();
    this.barSteps = this.querySelectorAll('.bar-step');
    this.barText = this.querySelector('.cart-bar__text');
    this.barProgress = this.querySelector('.cart-bar__progress-inner');
  }
  async connectedCallback() {
    const connector = window.themeConnector;
    if (!connector) {
      return;
    }
    this.initBarStepPositions(connector);
    await this.renderText(connector);
    await this.renderActive(connector);
  }
  initBarStepPositions(connector) {
    const rulePositions = connector.getRulePositions();
    this.barSteps.forEach((step) => {
      const ruleID = step.dataset.ruleId;
      const position = rulePositions.find((rule) => rule.ruleID === ruleID)?.position || 0;
      step.style.left = `${position * 100}%`;
    });
  }
  async renderText(connector) {
    const formattedText = await connector.getFormattedText();
    this.barText.textContent = formattedText;
  }
  async renderActive(connector) {
    const qualifiedRules = await connector.getQualifiedRules();
    this.barSteps.forEach((step) => {
      const ruleID = step.dataset.ruleId;
      const qualifiedRule = qualifiedRules.find((rule) => rule.ruleID === ruleID);
      step.classList.toggle('active', !!qualifiedRule);
    });
  }
  animateProgressBar(oldProgress, newProgress) {
    animate14(
      this.barProgress,
      { width: [`${oldProgress}%`, `${newProgress}%`] },
      { duration: 0.3, delay: 0, easing: [0.25, 0.46, 0.45, 0.94] },
    );
  }
  setProgressWidth(progress) {
    this.barProgress.style.width = `${progress}%`;
  }
}

if (!window.customElements.get('cart-bar')) {
  window.customElements.define('cart-bar', CartBar);
}
